module.exports = __webpack_public_path__ + "img/index_01_pic@2x.2363edf0.png";